import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CompanyCategoryModel } from 'src/models';

const companyCategoryAdapter: AdapterFunc<GQL.CompanyCategoryDbModel, CompanyCategoryModel> = (
  input,
) => ({
  id: input.id,
  name: input.name!,
  description: input.description!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default companyCategoryAdapter;
